<template>
    <div :class="class">
        <div class="modal-button" @click="display = !display">
            <slot name="button"></slot>
        </div>
        <Dialog v-model:visible="display" :modal="true" :dismissableMask="true">
            <slot name="modal"></slot>
        </Dialog>
    </div>
</template>

<script>
import Dialog from 'primevue/dialog/sfc';

export default {
    
    props: {
        class: String
    },

    data() {
        return {
            display: false
        }
    },

    components: {
        Dialog
    },

};
</script>